import React, {ReactNode, useCallback, useMemo, useState} from 'react';
import {Select, MenuItem, FormControl, InputLabel, Stack, Theme} from '@mui/material';
import {Option} from "./AbstractDropDown";
import {SxProps} from "@mui/system";

export interface AbstractDropDownProps {
    options: Option[]
    value: string[]
    label: string|ReactNode
    onChange:(value:string[]) => void
    sx?: SxProps<Theme>
    single?: boolean
    submitHappen?: boolean
    disabled?: boolean
    className?: string
    renderValueWrapper?: (selectedOptions:ReactNode[]) => React.ReactNode
}

export function AbstractDropDownMultiple ({renderValueWrapper, disabled, className, single, sx, value, label, options, onChange}:AbstractDropDownProps){
    const id = useMemo(() => Math.random() + "", []);
    const optionsMap = useMemo(() => {
        return options.reduce((map, opt) => {
            map[opt.value] = opt;
            return map;
        }, {} as Record<string, Option>)
    }, [options])
    const optionsToSelect = options.filter(o => value.indexOf(o.value.toString()) === -1);
    const [open, setOpen] = useState(false);

    const optionBuilder = useCallback((opt:Option) => {
        return <div
            key={opt.value}
            className={"dropdown-option"}
            onMouseDown={(e) => {
                e.stopPropagation();
            }}
            onClick={() => {
                const newValues = [...value];
                const index = newValues.indexOf(opt.value.toString());
                newValues.splice(index, 1);
                onChange(newValues);
            }}>
            {opt.label}
        </div>
    }, [onChange, value]);
    
    const thisRenderValueWrapper = useCallback((selected:string[]) => {
        const selectedOptions = selected.map(v => optionsMap[v])
                .filter(v => v)
                .map(optionBuilder);
        if(renderValueWrapper) {
            return renderValueWrapper(selectedOptions);
        }
        return <Stack flexDirection={"row"} flexWrap={'wrap'} gap={"10px"} /*style={{position: 'relative', zIndex: 10000}}*/>
            {selectedOptions}
        </Stack>
    }, [renderValueWrapper, optionsMap, optionBuilder])

    return (
        <FormControl variant="outlined" className={className} fullWidth>
            <InputLabel id={id}>{label}</InputLabel>
            <Select
                open={open}
                disabled={disabled}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                sx={sx}
                labelId={id}
                multiple
                renderValue={thisRenderValueWrapper}
                value={value}
                label={label}
                onChange={(e) => {
                    onChange(e.target.value as string[])
                    if(single) {
                        setOpen(false);
                    }
                }}
            >
                {optionsToSelect.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}